'use client';

import { OrderType } from '@velocity-exchange/sdk';
import { ENUM_UTILS } from '@velocity-exchange/common';
import TextButton from 'src/components/primitives/TextButton/TextButton';
import Divider from 'src/components/primitives/Divider/Divider';
import useModal from 'src/components/Modals/hooks/useModal';
import { useCancelOrders } from 'src/hooks/trade/cancel/useCancelOrders';
import { AccountOrder } from '../types';

interface EditCellProps {
	order: AccountOrder;
}

export function EditCell({ order }: EditCellProps) {
	const { show } = useModal();
	const { cancelOrders } = useCancelOrders();

	const isMarketOrder =
		ENUM_UTILS.match(order.orderType, OrderType.MARKET) ||
		ENUM_UTILS.match(order.orderType, OrderType.ORACLE);
	const shouldShowEditButton = !isMarketOrder;

	return (
		<div className="flex items-center justify-center">
			<div className="flex items-center justify-end gap-sm">
				{shouldShowEditButton && (
					<>
						<TextButton
							variant="tertiary"
							size="sm"
							onClick={(e) => {
								e.stopPropagation();
								show({ type: 'edit_order', props: { order } });
							}}
							dataTestId="order-edit"
						>
							Edit
						</TextButton>
						<Divider vertical />
					</>
				)}
				<TextButton
					variant="tertiary"
					size="sm"
					onClick={(e) => {
						e.stopPropagation();
						const toastId = `order-row-cancel-order-${order.orderId}-${Date.now()}`;
						cancelOrders(toastId, order.orderId);
					}}
					dataTestId="order-cancel"
				>
					Cancel
				</TextButton>
			</div>
		</div>
	);
}
